import { useState } from "react";
import DashboardContext from "./DashboardContext";

const DashboardState = ({ children }) => {
    const [controlTabIndex, setControlTabIndex] = useState("dashboard");
    const [popupImage, setPopupImage] = useState(null);

    const dashboardValues = {
        controlTabIndex,
        setControlTabIndex,
        popupImage,
        setPopupImage,
    };
    return (
        <DashboardContext.Provider value={dashboardValues}>
            {children}
        </DashboardContext.Provider>
    );
};

export default DashboardState;
